<template>
    <div>
        <!-- 搜索 -->
        <search  :search="true" :type="'SystemManagement'" @add-data="add_data" @search-data="search_data" @Export="Export"></search>
        <!-- 列表 -->
        <tables id="table-box"  :tableData="tableData"  :tableLabel="tableLabel" :ifheader="false" :Calculate="false" @event-button="event_button" ></tables>
        <!-- 新增系统 -->
        <el-dialog :close-on-click-modal="false" :visible.sync="New_System" :title="title"  :width="'720px'" v-if="New_System">
            <NewSystem :visibles.sync="New_System" @Render="Render" :type="type" :row="row"></NewSystem>
        </el-dialog>
        <!-- 关联权限 -->
        <el-dialog :close-on-click-modal="false" :visible.sync="New_permissions" :title="title"  :width="'720px'" v-if="New_permissions">
            <SystemAssignPermissions :visibles.sync="New_permissions" @Render="Render" :type="type" :row="row"></SystemAssignPermissions>
        </el-dialog>
        <!-- 关联菜单 -->
        <el-dialog :close-on-click-modal="false" :visible.sync="New_Context_Menu" :title="title"  :width="'720px'" v-if="New_Context_Menu">
            <SystemdistributionMenu :visibles.sync="New_Context_Menu" @Render="Render" :type="type" :row="row"></SystemdistributionMenu>
        </el-dialog>
         <!-- 分页 -->
        <pagination
            v-show="(Number(total) > 0)"
            :total="Number(total)"
            :page.sync="matterParams.current"
            :limit.sync="matterParams.size"
            @pagination="Render"
        />
    </div>
</template>
<script>
import SystemAssignPermissions from '../dialog/SystemAssignPermissions'
import NewSystem from '../dialog/NewSystem'
import SystemdistributionMenu from '../dialog/SystemdistributionMenu'
// import { openLoading } from '@/components/el-loading'

export default {
  components: {
    NewSystem,
    SystemAssignPermissions,
    SystemdistributionMenu
  },
  // props: {
  // '': {
  //    type:Object|Array|String|Boolean|Number
  //  }
  // },
  data () {
    return {
      New_permissions: false,
      New_System: false,
      New_Context_Menu: false,
      New_Associated_User: false,
      title: '',
      total: 0,
      type: '',
      row: {},
      matterParams: {
        // 默认显示页数
        current: 1,
        // 一页几条数据
        size: 10,
        orders: 'gmtCreate|desc'
      },
      tableData: [
      ],
      tableLabel: [
        { label: '序号', width: '80', prop: 'index', type: '', align: 'center' },
        { label: '系统名称', width: '200', prop: 'name', align: 'center' },
        { label: '服务名', width: '200', prop: 'serviceName', align: 'center' },
        { label: '描述', width: '', prop: 'description', align: 'center' },
        {
          label: '操作',
          width: '',
          align: 'center',
          isOpera: true, // 判断是否生成按钮
          ifshow: false, // 是否导出该内容
          titleList: [
            { title: '分配权限', status: 'primary' },
            { title: '分配菜单', status: 'primary' },
            { title: '修改', status: 'primary' },
            { title: '删除', status: 'primary' }
          ]
        }
      ]
    }
  },
  methods: {
    // 新增
    add_data (v) {
      this.title = '新增系统'
      this.New_System = true
      this.type = 'add'
      this.row = {}
    },
    // 查询数据
    search_data (row, type) {
      this.matterParams.current = 1

      Object.assign(this.matterParams, row)
      this.Render()
    },
    // 导出
    Export () {
      this.tableLabel[4].ifshow = true
      setTimeout(() => {
        this.$tableToExcel('#table-box .el-table', '系统信息.xlsx')
        this.tableLabel[4].ifshow = false
      })
      this.$message.success('导出成功')
    },
    // 列表按钮
    event_button (type, row) {
      if (type === '修改') {
        this.New_System = true
        this.title = '修改系统'
        this.type = 'edit'
        this.row = row
      } else if (type === '删除') {
        this.$confirm(`此操作将永久删除<span style="color:red"> ${row.name} </span> 该部门, 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          dangerouslyUseHTMLString: true // 将dangerouslyUseHTMLString属性设置为 true，message 就会被当作 HTML 片段处理
        }).then(() => {
          this.$http.Delete('/ucenter/sys-model/deleteSysModel', { id: row.id }).then((res) => {
            this.$message.success('删除成功')
            this.Render()
          })
        }).catch(() => {})
      } else if (type === '新增角色') {
        this.New_System = true
        this.title = '新增角色'
        this.type = 'AddMenu'
        this.row = row
      } else if (type === '关联用户') {
        this.New_Associated_User = true
        this.title = '关联用户'
        this.row = row
      } else if (type === '分配菜单') {
        this.$http.get('/ucenter/sys-model/queryModelRootMenuByModeId', { modelId: row.id }).then((res) => {
          if (res.data) {
            this.$set(row, 'ids', res.data)
          } else {
            this.$set(row, 'ids', '')
          }
          setTimeout(() => {
            this.New_Context_Menu = true
          }, 300)
          this.row = row
          this.title = '关联菜单'
        })
      } else if (type === '分配权限') {
        this.$http.get('/ucenter/sys-model/queryModelPermissionByModeId', { modelId: row.id }).then((res) => {
          if (res.data) {
            this.$set(row, 'ids', res.data.permissionId)
          } else {
            this.$set(row, 'ids', '')
          }
          setTimeout(() => {
            this.New_permissions = true
          }, 300)
          this.row = row
          this.title = '关联权限'
        })
      }
    },
    // 列表数据
    Render () {
      this.$http.get('/ucenter/sys-model/queryPage', this.matterParams).then((res) => {
        this.tableData = res.data.records
        this.total = res.data.total
      })
      // this.$http.get('/dict/department/queryPageTree', this.matterParams).then((res) => {
      //   this.tableData = res.data.records
      //   this.tableData = res.data.records
      //   this.total = res.data.total
      // })
    }
  },
  created () {
    this.Render()
  },
  watch: {
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>
</style>
